import {
    Component,
    OnInit,
    OnDestroy
} from '@angular/core';
import * as _ from 'lodash';import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { CommonService } from '../../services/index';
@Component({
    selector: 'my-notifications',
    templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {
    hasNotification: boolean = false;
    temp_flag: boolean = false;
    notificationCall: any;
    notificationList = [];
    currentdata = [];
    temp_data = [];
    CurrentDate;
    isLoadMask: Promise<any>;

    constructor(private commonService: CommonService, public toasterService: ToasterService) {}
    
    ngOnInit() {
        // this.getnotificationList();
    }

    ngOnDestroy() {
        clearInterval(this.notificationCall);
    }

    // Handle Notification icon click
    toggleNotifyList() {
        if (this.notificationList.length) {
            var modal = document.getElementById("notificationModal");
            modal.style.display = "block";
            this.temp_flag = !this.temp_flag;
            if (!this.temp_flag) {
                this.hasNotification = false;
                modal.style.display = "none";
            }
        }
    }

    // To remove notification from list i.e., notification status is changed to DONE
    removeNotification(index, hasCurrentNotification = false) {
        let that = this;
        const params = {
            not_id: this.notificationList[index].not_id
        };
        
        this.isLoadMask = this.commonService.removeNotification(params).then(function (res: any) {
            if (res && res.success) {
                that.notificationList.splice(index, 1);
                if (!that.notificationList.length) {
                    that.hasNotification = false;
                }
                if (hasCurrentNotification) {
                    that.setCurrentNotificationInterval();
                }
            } else {        
                const toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: res.message ? res.message : 'Oops, Something Went Wrong'
                };
                that.toasterService.pop(toast);
            }
        });

    }

    // To get list of notification which are in 'NEW' status
    getnotificationList() {
        let that = this;
        let params = {};
        that.commonService.getNotificationList(params).then(function (res: any) {
            that.notificationList = res.data;
            if (that.notificationList && that.notificationList.length > 0) {
                that.hasNotification = true;
            }
            that.setCurrentNotificationInterval();
        });
    }

    // To set interval method for calling current notification method
    setCurrentNotificationInterval() {
        let that = this;
        that.notificationCall = setInterval(() => {
            that.CurrentDate = new Date();
            that.getCurrentNotification();
        }, 2*60*1000);
    }

    // To get current notifcation details
    getCurrentNotification() {
        let that = this;
        let params = {
            data: that.notificationList.map(item => item.not_id).join(),
            date: that.CurrentDate
        };
        that.commonService.getCurrentNotification(params).then(function (res: any) {
            that.currentdata = res.data;
            if (that.currentdata && that.currentdata.length) {
                that.notificationList.push(that.currentdata[0]);
                clearInterval(that.notificationCall);
                let displayDate = that.currentdata[0].disp_date;
                if (that.currentdata[0].notification_type === 'Therapy Reminder') {
                    const parts = displayDate.split('-');
                    const d = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
                    d.setDate(d.getDate() + 1);
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    displayDate = dd + '-' + mm + '-' + d.getFullYear();
                }
                swal({
                    title: 'NOTIFICATION',
                    text: that.currentdata[0].content + ' - ' + displayDate,
                    //type: "success",
                    imageUrl: 'assets/images/smile.png',
                    imageWidth: 100,
                    imageHeight: 100,
                    confirmButtonText: 'OK',
                    customClass : "swalNotificationClass",
                    confirmButtonColor: '#98FB98',
                    allowOutsideClick: false,
                    
                }).then(res => {
                    that.removeNotification(that.notificationList.length -1, true);
                });
            }
        });
    }

    getNotificationDisplayDate(notification: any): string {
        if (notification.notification_type === 'Therapy Reminder') {
            const parts = notification.disp_date.split('-');
            const d = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
            d.setDate(d.getDate() + 1);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            return dd + '-' + mm + '-' + d.getFullYear();
        }
        return notification.disp_date;
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/home/notifications.component.ts